import React from 'react';
import { makeStyles } from '@material-ui/core';

////////// COMPONENT //////////
export default function Content(props) {
  const cls = useStyles();

  return (
    <div className={cls.content}>
      <div className={cls.contentNav} />
      <div className={cls.contentPage}>{props.children}</div>
    </div>
  );
}

////////// STYLES //////////
const useStyles = makeStyles(theme => ({
  content: {
    display: 'block',
    position: 'relative',
    width: '100%',
    height: '100vh',
  },
  contentNav: {
    display: 'block',
    position: 'relative',
    width: '100%',
    height: '56px',
  },
  contentPage: {
    display: 'block',
    position: 'relative',
    width: '100%',
  },
}));
